import { AccountsScreen } from "./accounts.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { AccountEditRoutes } from "../account-edit";

export const AccountsRoutes: RouteDefinition[] = [
	{
		path: Paths.accounts.path,
		element: <AccountsScreen />,
		requiredPermissions: ["UserInAccountPermission_Auth_Read"],
	},
	...AccountEditRoutes,
];
